import React from 'react';
import { Formatter } from './models';

export interface DashboardSourceCodeTabProps {
  activeFormatter: Formatter;
  setFormatter: (formatter: Formatter) => void;
  formatter: Formatter;
}

export const DashboardSourceCodeTab: React.FC<DashboardSourceCodeTabProps> = ({
  activeFormatter,
  setFormatter,
  formatter,
}) => {
  const isActive = activeFormatter === formatter;

  return (
    <button
      className={`text-[.87rem] font-normal px-4 py-1 transition-colors duration-200 border-b ${
        isActive ? 'border-b-2 border-blue-500 text-blue-500 text-bold' : 'border-b-2 border-gray-300 text-gray-300'
      }`}
      onClick={() => setFormatter(formatter)}
    >
      {formatter.toUpperCase()}
    </button>
  );
};
